import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { createStore } from './store';
import vuetify from './plugins/vuetify';
import { loadWeb3 } from '@/utils/web3';
import { walletConnectInit } from '@/utils/walletConnect';
import { createI18n } from './i18n';
import '@/filters';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import '@/assets/sass/index.sass';

// @ts-ignore
import VueCountdown from '@chenfengyuan/vue-countdown';

declare global {
  interface Window {
    ethereum: any;
    web3: any;
  }
}

Vue.config.productionTip = false;

Vue.component(VueCountdown.name, VueCountdown);

const store = createStore();
/* tslint:disable:no-string-literal */
const i18n = createI18n(store.getters['lang']);

loadWeb3(store);

const vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');


// walletConnectInit(vue);
